import { useState } from "react";
import { capitalizeFirstLetters } from "../../../utils/stringUtils";
import { cases } from "../resources";
import { useCaseContext } from "../../../context/CaseContext";
import SubmitSkeleton from "../SubmitSkeleton";

import arrowRight from "../../../images/arrow-right.svg";

const CaseTypeChoice = ({ setStep }: { setStep: (step: number) => void }) => {
  const [errorMessage, setErrorMessage] = useState("");
  const { caseType, updateCaseData } = useCaseContext();

  const isOtherCase = typeof caseType === "object" && caseType?.custom;

  const handleCaseTypeClick = (option: string) => {
    if (option === "other") {
      updateCaseData("caseType", { custom: true, customValue: "" });
    } else {
      updateCaseData("caseType", option);
      setStep(1);
    }
  };

  const handlePrev = () => {
    updateCaseData("caseType", null);
    setStep(0);
  };

  const handleNext = () => {
    if (
      isOtherCase &&
      (!caseType.customValue || caseType.customValue?.length === 0)
    ) {
      setErrorMessage("Please input case type before proceeding.");
    } else {
      setStep(2);
    }
  };

  if (isOtherCase) {
    return (
      <SubmitSkeleton
        title="What do you want to report?"
        onPrev={handlePrev}
        onNext={handleNext}
        progress={1 / 10}
      >
        <div className="flex flex-col">
          {errorMessage && (
            <p className="text-red-500 text-sm mb-3">{errorMessage}</p>
          )}

          <input
            type="text"
            name="caseType"
            placeholder="Please specify case type"
            value={caseType.customValue}
            onChange={(e) =>
              updateCaseData("caseType", {
                custom: true,
                customValue: e.target.value,
              })
            }
            className="font-medium mt-[1px] text-sm leading-4 text-gray-7 w-full box-border border border-gray-3 rounded-md py-2 px-3 outline-none focus:ring-1 focus:ring-black focus:border-transparent cursor-pointer"
          />
        </div>
      </SubmitSkeleton>
    );
  }

  return (
    <SubmitSkeleton title="I want to report" hasNav={false} progress={0 / 10}>
      <div className="flex flex-col gap-0 xs:gap-4">
        <div className="flex flex-col gap-1">
          {cases.map((individualCase, i) => (
            <button
              key={i}
              onClick={() => handleCaseTypeClick(individualCase)}
              className="flex justify-between items-center border-b-2 border-[#E0E0E0] py-[14px] pr-[7px] pl-3 xs:pr-[15px] font-medium text-[14px] xs:text-base leading-[16px] text-gray-7"
            >
              <p>{capitalizeFirstLetters(individualCase)}</p>
              <img src={arrowRight} alt="right" />
            </button>
          ))}
        </div>
      </div>
    </SubmitSkeleton>
  );
};

export default CaseTypeChoice;
